export default {
    Translate: {
        Title: "Dịch thuật",
        text: 'Nội dung cần dịch',
        text_dest: 'Kết quả dịch'
    },
    Exploit:{
        Title: "Sinh mã khai thác",
        text: 'Dữ liệu đầu vào',
        text_desc: 'Mã CVE, mô tả lỗ hổng...',
        text_dest: 'Mã khai thác',
        vulnerability_type: 'Phân loại lỗ hổng',
        target_system: 'Hệ thống ảnh hưởng',
    },
    Report:{
        Title: "Báo cáo thông minh",
        Input: "Tham số đầu vào",
        Output: "Kết quả phân tích",
        Button: "Phân tích thông minh"
    }
};  
